import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfigModule } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { I18nModule, TranslatePipe } from '../../../../core/i18n';
import { DrawerModule, MegamenuListItemsModule, PipesModule, SpinnerModule } from '../../../../shared';
import { SearchModule } from '../../../../shared/components/search/search.module';
import { LoginModule } from '../../../login/login.module';
import { CampaignsSubNavigationModule } from '../../components/campaigns-sub-navigation/campaigns-sub-navigation.module';
import { CategoriesNavigationModule } from '../../components/categories-navigation/categories-navigation.module';
import { HeaderNavigationItemModule } from '../../components/header-navigation-item';
import { MenuAreaOfUseCategoriesModule, MenuAreaOfUseSubCategoriesModule } from '../../components/menu-area-of-use';
import { MobileNavigationLinksModule } from '../../components/mobile-navigation-links/mobile-navigation-links.module';
import { MobileNavigationServicesModule } from '../../components/mobile-navigation-services/mobile-navigation-services.module';
import { MyAssortmentSubNavigationModule } from '../../components/my-assortment-sub-navigation/my-assortment-sub-navigation.module';
import { SubAddonGroupNavigationModule } from '../../components/sub-addon-group-navigation/sub-addon-group-navigation.module';
import { SubCategoriesNavigationModule } from '../../components/sub-categories-navigation/sub-categories-navigation.module';
import { MenuCartAnonymousComponent } from '../menu-cart/menu-cart-anonymous/menu-cart-anonymous.component';
import { MenuCartAuthenticatedComponent } from '../menu-cart/menu-cart-authenticated/menu-cart-authenticated.component';
import { MenuCartModule } from '../menu-cart/menu-cart.module';
import { MyPageMenuModule } from '../my-page-menu/my-page-menu.module';
import { MobileNavigationComponent } from './mobile-navigation.component';

@NgModule({
  declarations: [MobileNavigationComponent],
  imports: [
    NzIconModule,
    CommonModule,
    MyPageMenuModule,
    HeaderNavigationItemModule,
    SearchModule,
    LoginModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CmsMobileNavigationComponent: {
          component: MobileNavigationComponent,
        },
      },
    }),
    DrawerModule,
    MenuCartModule,
    InfiniteScrollModule,
    MobileNavigationLinksModule,
    CategoriesNavigationModule,
    SubCategoriesNavigationModule,
    CampaignsSubNavigationModule,
    MyAssortmentSubNavigationModule,
    SubAddonGroupNavigationModule,
    MobileNavigationServicesModule,
    MenuAreaOfUseCategoriesModule,
    MenuAreaOfUseSubCategoriesModule,
    SpinnerModule,
    ReactiveFormsModule,
    PipesModule,
    MegamenuListItemsModule,
    MenuCartAuthenticatedComponent,
    MenuCartAnonymousComponent,
  ],
  providers: [TranslatePipe],
  exports: [],
})
export class HeaderMobileNavigationModule {}
